import React from 'react';
import { FormattedMessage } from 'react-intl';

const HINT_TITLE = 'components.overview.greece-hint-title';
const HINT_TEXT_1 = 'components.overview.greece-hint-text-1';
const HINT_TEXT_2 = 'components.overview.greece-hint-text-2';

/**
 * Hinweis zu möglichen Gebühren in griechischen Häfen
 */
export default function GreeceHint () {
    return (
        <section className="check-section">
            <div className="row">
                <div className="col-xs-12 text-wrapper greece-hint">
                    <div className="section-headline greece-hint-headline">
                        <FormattedMessage id={HINT_TITLE} />
                    </div>
                    <div><FormattedMessage id={HINT_TEXT_1} /></div>
                    <div><FormattedMessage id={HINT_TEXT_2} /></div>
                </div>
            </div>
        </section>
    );
}
